import React from 'react';
import { Link } from 'react-router-dom';
import { NavigationItems } from './NavigationItems';
import { ThemeToggleButton } from './ThemeToggleButton';
import { LanguageSelector } from './LanguageSelector';
import SyncStatusIndicator from './SyncStatusIndicator';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose }) => {
  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-25 transition-opacity lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Slide-out menu */}
      <div
        className={`fixed inset-y-0 right-0 z-50 w-64 transform overflow-y-auto bg-white p-6 shadow-xl transition-transform duration-300 ease-in-out dark:bg-gray-800 lg:hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Close button */}
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 dark:hover:bg-gray-700"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Logo */}
        <div className="mb-8">
          <Link to="/landing" className="flex items-center" onClick={onClose}>
            <img src="/logo.svg" alt="FairBalance Logo" className="h-8 w-8" />
            <span className="ml-2 text-xl font-bold text-gray-800 dark:text-white">
              FairBalance
            </span>
          </Link>
        </div>

        {/* Navigation Items */}
        <div className="mb-8">
          <NavigationItems className="flex-col space-y-2" showLabels={true} />
        </div>

        {/* Settings */}
        <div className="space-y-4 border-t border-gray-200 pt-6 dark:border-gray-700">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-500 dark:text-gray-400">Theme</span>
            <ThemeToggleButton />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-500 dark:text-gray-400">Language</span>
            <LanguageSelector />
          </div>
        </div>

        {/* Sync Status */}
        <div className="absolute bottom-6 left-6 right-6">
          <SyncStatusIndicator />
        </div>
      </div>
    </>
  );
};
